import { apiService } from "../services/api.service";
import { authenticationService } from "../services/authentication.service";

export const prijemBalikaController = {
    getBalikByCiarovyKod,
    potvrditPrijemDodavky,
    jeMaterial,
    suToTasky,
    notifikacniEmail,
    pridatKus,
    odebratKus,
    zrusitPrijem,
    refreshStavSkenovaniaPoloziekBalika,
    validacePolozkyBezKodu,
    pridatKusBezCiarovehoKodu,
    ulozitBalik,
    jeMozneNahlasitDodavku,
    TEMP_CiarovyKodZBalika,
    TEMP_CiarovyKodMimoBalika,
    TEMP_CiarovyKodZBalika_InaFarba,
    TEMP_CiarovyKodZBalika_InaVelkost,
    TEMP_GetPocetBaliku,
    TEMP_GetKodBalika,
    potvrdPrijemDodavkyAktualizovatZoznam,
    potvrdPrijemDodavkyNaskenovanimBalika
};

function getBalikByCiarovyKod(ciarovyKod, idDodavka) {
    return apiService.fetchApiRequest("api/PrijemBalika/GetBalikFromCiarovyKod?ciarovyKod=" + ciarovyKod + "&idDodavka=" + idDodavka);
}

function potvrditPrijemDodavky(idDodavka, idBalik, ciarovyKodDodavky, malByBytKodDodavky, spytatsaCiPotvrdit, datum, upozornitAkBolaPrijata) {
    const prijemDodavky = {
        idBalik: idBalik,
        ciarovyKod: ciarovyKodDodavky,
        malByBytKodDodavky: malByBytKodDodavky,
        spytatsaCiPotvrdit: spytatsaCiPotvrdit,
        datumPrijmu: datum,
        upozornitAkBolaPrijata: upozornitAkBolaPrijata,
        idDodavka: idDodavka
    };

    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ prijemDodavky })
    };
    return apiService.fetchApiRequest("api/PrijemBalika/PotvrdPrijemDodavky", false, requestOptions);
}

function jeMaterial(balik) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/JeMaterial", false, requestOptions);
}

function suToTasky(balik) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/SuToTasky", false, requestOptions);
}

function notifikacniEmail(datum, datumExpedicie, idDodavka) {
    const notifikacniEmailModel = {
        datum: datum,
        datumExpedicie: datumExpedicie,
        idDodavka: idDodavka
    };
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(notifikacniEmailModel)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/NotifikacniEmailPotvrdeniaPrijmu", false, requestOptions);
}

function pridatKus(balik, ciarovyKod) {
    balik.skenCiarovyKod = ciarovyKod;
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/PridatKus", false, requestOptions);
}

function odebratKus(balik, id) {
    balik.odebiranyKusId = id;
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/OdstranitKus", false, requestOptions);
}

function zrusitPrijem(balik) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/ZrusitPrijem", false, requestOptions);
}

function refreshStavSkenovaniaPoloziekBalika(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/RefreshStavSkenovaniaPoloziekBalika", false, requestOptions);
}

function validacePolozkyBezKodu(cisloKarty) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ cisloKarty })
    };
    return apiService.fetchApiRequest("api/PrijemBalika/ValidacePolozkyBezKodu", false, requestOptions);
}

function pridatKusBezCiarovehoKodu(prijemBalika, idVariant, idVelikost) {
    const currentUser = authenticationService.currentUserValue;
    const kusBezCiarovehoKoduModel = {
        prijemBalika: prijemBalika,
        idVariant: idVariant,
        idVelikost: idVelikost
    };
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(kusBezCiarovehoKoduModel)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/PridatKusBezCiarovehoKodu", false, requestOptions);
}

function ulozitBalik(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/UlozitBalik", false, requestOptions);
}

function jeMozneNahlasitDodavku(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/JeMozneNahlasitDodavku", false, requestOptions);
}

function TEMP_CiarovyKodZBalika(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/TEMP_CiarovyKodZBalika", false, requestOptions);
}

function TEMP_CiarovyKodMimoBalika(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/TEMP_CiarovyKodMimoBalika", false, requestOptions);
}

function TEMP_CiarovyKodZBalika_InaFarba(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/TEMP_CiarovyKodZBalika_InaFarba", false, requestOptions);
}

function TEMP_CiarovyKodZBalika_InaVelkost(balik) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(balik)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/TEMP_CiarovyKodZBalika_InaVelkost", false, requestOptions);
}

function TEMP_GetPocetBaliku(idDodavka) {
    return apiService.fetchApiRequest("api/PrijemBalika/TEMP_GetPocetBaliku?idDodavka=" + idDodavka);
}

function TEMP_GetKodBalika(idDodavka, poradoveCislo) {
    return apiService.fetchApiRequest("api/PrijemBalika/TEMP_GetKodBalika?idDodavka=" + idDodavka + "&poradoveCislo=" + poradoveCislo);
}

function potvrdPrijemDodavkyAktualizovatZoznam() {
    return apiService.fetchApiRequest("api/PrijemBalika/PotvrdPrijemDodavkyAktualizovatZoznam");
}

function potvrdPrijemDodavkyNaskenovanimBalika(ciarovyKod, potvrdenyDialog) {
    const currentUser = authenticationService.currentUserValue;

    const potvrdeniePrijmuModel = {
        ciarovyKodBalika: ciarovyKod,
        potvrdeny: potvrdenyDialog
    };

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(potvrdeniePrijmuModel)
    };
    return apiService.fetchApiRequest("api/PrijemBalika/PotvrdPrijemDodavkyNaskenovanimBalika", false, requestOptions);
}



// WEBPACK FOOTER //
// ./src/controllers/prijembalika.controller.js